export default {
  yandexdirect: 'yandex',
  googleads: 'adv',
  vkads: 'vk-ads',
}
